"use client";
import { useProps } from "../../../core/MantineProvider/use-props/use-props.mjs";
import { factory } from "../../../core/factory/factory.mjs";
import { Box } from "../../../core/Box/Box.mjs";
import Combobox_module_default from "../Combobox.module.mjs";
import { useComboboxContext } from "../Combobox.context.mjs";
import { jsx } from "react/jsx-runtime";
//#region packages/@mantine/core/src/components/Combobox/ComboboxFooter/ComboboxFooter.tsx
const ComboboxFooter = factory((props) => {
	const { classNames, className, style, styles, vars, ...others } = useProps("ComboboxFooter", null, props);
	return /* @__PURE__ */ jsx(Box, {
		...useComboboxContext().getStyles("footer", {
			className,
			classNames,
			style,
			styles
		}),
		...others,
		onMouseDown: (event) => {
			event.preventDefault();
		}
	});
});
ComboboxFooter.classes = Combobox_module_default;
ComboboxFooter.displayName = "@mantine/core/ComboboxFooter";
//#endregion
export { ComboboxFooter };

//# sourceMappingURL=ComboboxFooter.mjs.map